





















import { Component, Prop, Vue } from 'vue-property-decorator';
import MenuEngineeringLogic from '@/logic/menu-engineering/MenuEngineeringLogic';
import Score from '@/logic/menu-engineering/Score';

@Component
export default class CategoryHeader extends Vue {
  @Prop(String)
  score!: Score;

  get attributes(): any {
    return this.getCategoryAttributes(this.score);
  }

  public getCategoryAttributes(score: Score): any[] {
    const label = MenuEngineeringLogic.getCategoryLabel(score);

    // Determine value
    let value = { text: '', score: '' };
    // eslint-disable-next-line default-case
    switch (score) {
      case Score.WINNER:
      case Score.SLEEPER:
        value = {
          text: `+ ${this.$t(`menuEngineering.label.${label}.profit`)}`,
          score: 'high',
        };
        break;
      case Score.RUNNER:
      case Score.LOSER:
        value = {
          text: `- ${this.$t(`menuEngineering.label.${label}.profit`)}`,
          score: 'low',
        };
        break;
    }

    // Determine demand
    let demand = { text: '', score: '' };
    // eslint-disable-next-line default-case
    switch (score) {
      case Score.WINNER:
      case Score.RUNNER:
        demand = {
          text: `+ ${this.$t(`menuEngineering.label.${label}.demand`)}`,
          score: 'high',
        };
        break;
      case Score.SLEEPER:
      case Score.LOSER:
        demand = {
          text: `- ${this.$t(`menuEngineering.label.${label}.demand`)}`,
          score: 'low',
        };
        break;
    }

    return [value, demand];
  }
}
